// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Libre+Franklin&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-flex-wrap {
  flex-wrap: unset !important;
}

.error-style {
  padding-left: 56px;
}

.login-container {
  position: relative;
  padding-top: 18vh !important;
  z-index: 2;
  width: 100%;
  max-width: 1140px;
  padding-right: 2vw;
  padding-left: 2vw;
  margin-right: auto;
}
.login-container *:not(i) {
  font-family: "Libre Franklin", sans-serif;
}

.top-bar-container {
  position: absolute;
  z-index: 2;
}
.top-bar-container .login-logo-container {
  position: absolute;
  top: 4vh;
}
.top-bar-container .login-logo-container img {
  max-height: 80px;
}

@media (max-width: 768px) {
  .mobile-login-box {
    margin: 0 auto !important;
  }
}

.sidebar-right {
  width: 25vw;
  min-width: 400px;
  max-width: 50vw;
  position: fixed;
  height: 100%;
  background-color: #DA291C;
  right: 0;
  top: 0;
  z-index: 1;
}
@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar-right {
    min-width: 345px;
  }
}
@media (max-width: 768px) {
  .sidebar-right {
    display: none;
    visibility: hidden;
  }
}
.sidebar-right .sidebar-content {
  position: relative;
  padding-left: 6%;
  padding-right: 6%;
  top: 25vh;
}
.sidebar-right .sidebar-content h4 {
  font-size: calc(48px + 6 * (100vw - 768px) / 1152);
  font-weight: bold;
  text-align: left;
  line-height: 1.3;
}
.sidebar-right .sidebar-content h4.smaller-title {
  font-size: calc(24px + 6 * (100vw - 768px) / 1152);
}
.sidebar-right .sidebar-content p {
  font-size: calc(18px + 2 * (100vw - 768px) / 1152);
  text-align: justify;
  line-height: 1.3;
}
.sidebar-right .sidebar-content p.smaller-text {
  font-size: calc(12px + 2 * (100vw - 768px) / 1152);
  overflow-y: auto;
  max-height: 46vh;
}
.sidebar-right .sidebar-content p.scroller {
  overflow-y: auto;
  scrollbar-color: transparent rgba(255, 255, 255, 0.4);
}
.sidebar-right .sidebar-content p::-webkit-scrollbar-track {
  background-color: transparent;
}
.sidebar-right .sidebar-content p::-webkit-scrollbar {
  width: 2px;
  background-color: transparent;
}
.sidebar-right .sidebar-content p::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
}
.sidebar-right .sidebar-content h4, .sidebar-right .sidebar-content p {
  color: white;
}
.sidebar-right .sidebar-logo {
  display: block;
  visibility: visible;
  position: absolute;
  bottom: 6%;
  left: 6%;
  right: 6%;
  z-index: 1;
}
.sidebar-right .sidebar-logo > img {
  width: 100%;
  max-width: 130px;
}

.login-full-background.video-background {
  position: fixed;
  z-index: 1;
  min-width: 100%;
  min-height: 100%;
}
@media (max-width: 768px) {
  .login-full-background.video-background {
    display: none !important;
    visibility: hidden !important;
    z-index: -1;
  }
}

.login-full-background.image-background {
  background-size: cover;
  background-position: top center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
